export default {
  getDisplayName: (WrappedComponent) => {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  },
};
